<template>
  <div id="app" class="app" v-cloak>
    <Header />
    <!-- <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <router-view /> -->
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "@/components/Head.vue";
import Footer from "@/components/Foot.vue";
import axios from '@/api/axios.js';
import { getLocalStorage } from '@/utils/tools.js'
export default {
  components: {
    Header,
    Footer
  },
  watch: {
    $route() {
      let token = getLocalStorage('token');
      if(token) {
        this.getLoginOnPersonInfo(token)
      }
    }
  },
  created () {
  },
  methods: {
    getLoginOnPersonInfo (token) {
      this.$store.commit('MAIL', !this.mail);
      //登陆后查看个人信息完成度，做响应跳转
      axios({
        method: "get",
        url: '/api/v1/web/auth/get_info',
        headers: {
          Authorization: token
        },
        data: {}
      }).then(rs => {
        if (rs.code == 200) {
          if (rs.data.enabled == 1) {
            // 跳转登录前的页面
            // localStorage.setItem('username', rs.data.name || '')
            // if (localStorage.getItem('routePath') && localStorage.getItem('routePath') != '/') {
            //   this.getHistoryRoute()
            // } else {
            //   // this.$router.go(-1);
            //   this.$router.push('/home');
            // }
          } else {
            this.$router.push('/perfectInfo');
          }
        }
      }).catch(e => {
        console.log(e)
      })
    },
    // 获取历史路由跳转
    getHistoryRoute () {
      let name = localStorage.getItem('routePath') + ''
      this.$router.push(name)
      localStorage.setItem('routePath', '')
    }
  }
};
</script>

<style lang="less">
img {
  backface-visibility:hidden;
  -webkit-backface-visibility:hidden;
}
.header .hover-style {
  position: relative;
}
.header .hover-style::before {
  content: '';
  position: absolute;
  width: 40px;
  height: 3px;
  background-color: #ad1d0f;
  left: 50%;
  bottom: -16px;
  transform: translateX(-50%);
}

#app {
  font-family: 'Noto Sans SC' !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #333130;
  background: #f4f4f4;
}
[v-cloak]{ display:none!important;}
/*清除默认边距*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
fieldset,
lengend,
button,
input,
textarea,
th,
td {
  margin: 0;
  padding: 0;
}
html {
  font-size: 62.5%;
  overflow-x: hidden;
}
cite,
em {
  font-style: normal;
}
/* 重置列表元素 */
ul,
ol {
  list-style: none;
}
/* 重置文本格式元素 */
a,
a:hover,
a:focus {
  text-decoration: none;
  cursor: pointer;
  outline: none;
  /*color: inherit;*/
}
/* 重置表单元素 */
legend {
  color: #000;
}
fieldset,
img {
  border: none;
}
img {
  width: auto;
  vertical-align: middle;
}
/* 重置表格元素 */
table {
  border-collapse: collapse;
  border-spacing: 0;
}
button,
input,
select,
textarea {
  font-size: 100%;
}
/*清除浮动*/
.clearfix:after {
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
  content: ' ';
}
.clearfix {
  _zoom: 1;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.pr {
  position: relative;
}
.pa {
  position: absolute;
}
.text-center {
  text-align: center;
}
// .pages{
//   .ivu-page-item:hover, .ivu-page-next:hover, .ivu-page-prev:hover{
//     border-color: #AE1E10;
//     a{
//       color: #fff;
//     }
//   }
//   .ivu-page-item-active{
//     border-color: #AE1E10;
//     a{
//       color: #fff;
//     }
//   }
//   .ivu-page-options-elevator input:hover{
//     border-color: #AE1E10;
//   }
// }
.button-order {
  display: block;
  width: 275px;
  height: 52px;
  background: #ae1e10;
  color: #fff;
  border: none;
  font-size: 26px;
  margin: 0 auto;
}
.ivu-select .ivu-select-arrow {
  margin-top: 0;
}
.bread {
  a {
    color: #333130;
    font-size: 18px;
    line-height: 20px;
  }
  span {
    color: #333130;
    font-size: 18px;
    line-height: 20px;
  }
}
.bread.ivu-breadcrumb > span.bread-last .ivu-breadcrumb-item-link {
  font-weight: normal;
  color: #ae1e10;
}
.bread-icon {
  width: 18px;
  height: 20px;
  vertical-align: top;
  margin-right: 10px;
}
.ivu-page-item-jump-next,
.ivu-page-item-jump-prev,
.ivu-page-next,
.ivu-page-prev {
  padding: 0 4px;
}

#demo {
  .ivu-form {
    /*.ivu-form-item-label {*/
      /*font-size: 18px;*/
      /*color: #000;*/
      /*font-weight: bold;*/
      /*padding: 0;*/
      /*line-height: 42px;*/
    /*}*/
    .ivu-form-item {
      margin-bottom: 18px !important;
    }
    .ivu-form-item-content {
      text-align: right;
    }
    .page-top {
      .ogg {
        margin-bottom: 0 !important;
      }
      .i-left label {
        text-align: left;
      }
      .item-label label {
        margin-left: 12px;
      }
      .ivu-form-item-content {
        text-align: right;
        width: 326px;
        float: right;
        margin-left: 0px !important;
      }
    }
    .page-center {
      label {
        text-align: left;
      }
    }
    .tjpepol {
      .ivu-form-item-label {
        text-align: left;
      }
      .ivu-form-item-content {
        text-align: left;
      }
      .item-forms {
        .ivu-form-item-content {
          display: flex;
          justify-content: flex-start;
          input {
            display: block;
          }
        }
      }
      .item-forms-2 {
        display: flex;
        justify-content: flex-start;
        .ivu-radio-wrapper {
          font-size: 14px;
        }
      }
      .ivu-input-suffix {
        display: none !important;
      }
      .ivu-input {
        border-radius: 0px;
        border-collapse: #cacaca;
      }
      .sg-tz {
        display: flex;
        label {
          margin-left: 38px;
          width: auto !important;
        }
        label:last-child {
          margin-left: 38px;
        }
        .ivu-form-item-content {
          margin-left: 87px !important;
        }
      }
      .phone-email {
        display: flex;
        .email label {
          text-align: right;
          margin-left: -15px;
        }
      }
      .jzd,
      .zlyj {
        display: flex;
        .labels {
          label {
            width: 120px !important;
          }
          .ivu-form-item-content {
            margin-left: 130px !important;
          }
        }
        .yb {
          label {
            width: auto !important;
            margin-left: 38px;
          }
          .ivu-form-item-content {
            margin-left: 89px !important;
          }
        }
      }
      .my {
        label {
          width: 75px !important;
          height: 42px;
        }
        .ivu-form-item-content {
          margin-left: 63px !important;
        }
      }
    }
    .label-with-radio [type='checkbox'] {
      vertical-align: bottom;
    }
    .dh,
    .mail {
      label {
        text-align: left !important;
      }
    }
  }
}
// .page-form {
//   .label-font .ivu-form-item-label {
//     vertical-align: middle;
//     font-size: 18px;
//     color: black;
//     width: auto !important;
//     // padding: 10px 0 10px;
//     // padding-right: 13px;
//     font-weight: bold;
//   }
//   .ogg label {
//     // padding-left: 20px !important;
//   }
//   .ivu-form-item-content{
//     // margin-left: 45px !important;
//   }
//   // .dianhua .ivu-form-item-content{
//   //   margin-left: 10px !important;
//   // }
//   .pepal-email label{
//     padding-left: 42px !important;
//   }
//   .bt {
//     margin-bottom:20px;
//   }
//   .qt {
//     margin-left:10px;
//   }
//   .ms label{
//     padding-left: 20px !important;
//   }
//   .dates {
//     i {
//       display: none;
//     }
//     .ivu-input {
//       border: 1px solid #bababa;
//       border-radius: 0;
//       outline: none;
//       font-size: 14px;
//       color: #000;
//     }
//   }
// }
a:hover {
  color: #2d8cf0;
}
.ivu-input-icon + .ivu-input {
  padding-right: 32px;
  height: 40px !important;
}
.ivu-anchor-link-title {
  line-height: 1.1;
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  //your styles here
  #app {
    min-width: 1266px;
  }
}
</style>
